module.exports = __webpack_public_path__ + "static/img/p2.80ff2888.png";